<template>
    <Breadcrumbs main="Pages" title="Internationalization" />
    <div class="container-fluid">
        <div class="row">
            <languageInternationa />
            <languagePicker />
            <languageView />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const languageInternationa = defineAsyncComponent(() => import("@/components/theme/internationalization/languageInternationa.vue"))
const languagePicker = defineAsyncComponent(() => import("@/components/theme/internationalization/languagePicker.vue"))
const languageView = defineAsyncComponent(() => import("@/components/theme/internationalization/languageView.vue"))
</script>